@if (showSplashLoader$ | async) {
  <div class="fixed z-[99999] w-screen h-screen" [ngClass]="{
    'opacity-75': (isBlockingLoader$ | async)
  }">
    <app-splash-loader />
  </div>
}

<router-outlet />

<zaeper-blocking-loader />
